var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loader",class:_vm.parent},[_c('v-skeleton-loader',{staticClass:"item_grid_album",attrs:{"type":"image, list-item-two-line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }